import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ClassicTextField } from '../Components/ClassicTextField';
import { PasswordTextField } from '../Components/PasswordTextField';
import { SignInLayout } from '../Layout/SignInLayout';
import { openAlert } from '../Store/AlertSlice';
import { signUp } from '../firebase/Auth/SignUp';
import { auth } from '../firebase/firebase';

export const SignUpPage: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [passwordConfirmation, setPasswordConfirmation] =
        useState<string>('');
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const signUpHandler = () => {
        if (
            email === '' &&
            firstName === '' &&
            lastName === '' &&
            password === '' &&
            passwordConfirmation === ''
        ) {
            dispatch(
                openAlert({
                    displayText: 'Všechna pole musí být vyplněna',
                    severity: 'error',
                }),
            );
            return;
        }
        if (password === passwordConfirmation) {
            if (/[A-Z]/.test(email)) {
                dispatch(
                    openAlert({
                        displayText: 'Email nemůže obsahovat velké písmeno',
                        severity: 'error',
                    }),
                );
                return;
            }
            signUp(email, firstName, lastName, password)
                .then((res) => {
                    setEmail('');
                    setFirstName('');
                    setLastName('');
                    setPassword('');
                    setPasswordConfirmation('');
                    auth.signOut();
                    navigate('/sign-in');
                    dispatch(
                        openAlert({
                            displayText: 'User created',
                            severity: 'success',
                        }),
                    );
                })
                .catch((err) => {
                    dispatch(
                        openAlert({
                            displayText: `Nelze vytvořit uživatel: ${err.message}`,
                            severity: 'error',
                        }),
                    );
                });
        } else {
            dispatch(
                openAlert({
                    displayText: `Hesla se neshodují`,
                    severity: 'error',
                }),
            );
        }
    };

    const onNameChangeHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setFirstName(e.currentTarget.value);
    };
    const onLastNameChangeHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setLastName(e.currentTarget.value);
    };

    const onEmailChangeHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setEmail(e.currentTarget.value);
    };

    const onPasswordChangeHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setPassword(e.currentTarget.value);
    };

    const onPasswordConfChangeHandler = (
        e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setPasswordConfirmation(e.currentTarget.value);
    };
    return (
        <SignInLayout>
            <Typography variant="h4" textAlign="center">
                Vytvořit nového uživatele
            </Typography>
            <ClassicTextField
                label="Jméno"
                value={firstName}
                changeValueHandler={onNameChangeHandler}
            />
            <ClassicTextField
                label="Příjmení"
                value={lastName}
                changeValueHandler={onLastNameChangeHandler}
            />
            <ClassicTextField
                label="email"
                value={email}
                changeValueHandler={onEmailChangeHandler}
            />
            <PasswordTextField
                label="Heslo"
                value={password}
                setValueHandler={onPasswordChangeHandler}
            />
            <PasswordTextField
                label="Potvrzení hesla"
                value={passwordConfirmation}
                setValueHandler={onPasswordConfChangeHandler}
            />
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    color="secondary"
                    variant="contained"
                    sx={{ width: '100px' }}
                    onClick={signUpHandler}
                >
                    <Typography variant="button" sx={{ fontWeight: 'bold' }}>
                        Vytvořit
                    </Typography>
                </Button>
            </Box>
        </SignInLayout>
    );
};
